import React from "react";
import TrialClientsComponent from "../../components/TrialClients/TrialClients.component";
import IPage from "../../interfaces/page"

const TrialClientsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <TrialClientsComponent></TrialClientsComponent>;
};

export default TrialClientsPage;
